(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.prods').forEach(function(root){
    var tabs = root.querySelectorAll('.tab');
    if (!tabs.length) return;
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        var id = t.getAttribute('data-tab');
        tabs.forEach(function(x){
          x.classList.remove('on');
          x.setAttribute('aria-selected', 'false');
        });
        t.classList.add('on');
        t.setAttribute('aria-selected', 'true');
        root.querySelectorAll('[data-panel]').forEach(function(p){
          p.hidden = p.getAttribute('data-panel') !== id;
        });
        root.querySelectorAll('[data-panel]:not([hidden]) .reveal').forEach(function(el){
          el.classList.add('is-in');
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
  var hdr = document.getElementById('SiteHeader');
  if (hdr) {
    var onScroll = function(){ hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* açılır menü: dokunmatik cihazda ilk dokunuş menüyü açsın */
  document.querySelectorAll('.nav__item--has-sub > a').forEach(function(a){
    a.addEventListener('click', function(e){
      if (window.matchMedia('(hover:none)').matches) {
        var item = a.parentElement;
        var open = item.classList.contains('is-open');
        document.querySelectorAll('.nav__item--has-sub').forEach(function(x){ x.classList.remove('is-open'); });
        if (!open) { e.preventDefault(); item.classList.add('is-open'); a.setAttribute('aria-expanded','true'); }
      }
    });
  });

  var toggle = document.getElementById('MenuToggle');
  var menu   = document.getElementById('MobileMenu');
  var scrim  = document.getElementById('MenuScrim');
  var closeB = document.getElementById('MenuClose');
  if (!toggle || !menu || !scrim) return;

  function open(){
    menu.classList.add('is-open');
    scrim.classList.add('is-open');
    document.body.classList.add('menu-open');
    toggle.setAttribute('aria-expanded','true');
  }
  function close(){
    menu.classList.remove('is-open');
    scrim.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    toggle.setAttribute('aria-expanded','false');
  }
  toggle.addEventListener('click', open);
  scrim.addEventListener('click', close);
  if (closeB) closeB.addEventListener('click', close);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-3d"] && !Shopify.designMode) return;
  try {
    
(function(){
  var vids = document.querySelectorAll('.hero__video');
  vids.forEach(function(v){
    if (v.dataset.wired) return;
    v.dataset.wired = '1';
    var isM = window.matchMedia('(max-width:760px)').matches;
    v.poster = isM ? v.getAttribute('data-poster-mobile') : v.getAttribute('data-poster-desktop');
    var src = isM ? v.getAttribute('data-src-mobile') : v.getAttribute('data-src-desktop');
    if (!src) return;
    var s = document.createElement('source');
    s.src = src;
    s.type = 'video/mp4';
    v.appendChild(s);
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function(){});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.pdp');
  if (!root) return;

  /* ---- galeri ---- */
  (function(){
    var main = root.querySelector('.gal__main img:not(.gal__bg)');
    var bg = root.querySelector('.gal__bg');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.gal__thumb'));
    var counter = root.querySelector('[data-gal-index]');
    if (!main || !thumbs.length) return;
    var idx = 0;
    function show(i){
      idx = (i + thumbs.length) % thumbs.length;
      main.src = thumbs[idx].getAttribute('data-full');
      /* bulanık dolgu da yeni görselle güncellensin, yoksa önceki
         görselin rengi kenarda kalır */
      if (bg) bg.src = thumbs[idx].getAttribute('data-bg') || thumbs[idx].getAttribute('data-full');
      main.classList.remove('gswap');
      void main.offsetWidth;
      main.classList.add('gswap');
      thumbs.forEach(function(t, k){
        t.setAttribute('aria-current', k === idx ? 'true' : 'false');
      });
      if (counter) counter.textContent = idx + 1;
    }
    thumbs.forEach(function(t, k){ t.addEventListener('click', function(){ show(k); }); });
    var prev = root.querySelector('[data-gal="prev"]');
    var next = root.querySelector('[data-gal="next"]');
    if (prev) prev.addEventListener('click', function(){ show(idx - 1); });
    if (next) next.addEventListener('click', function(){ show(idx + 1); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  })();

  /* ---- adet ---- */
  root.querySelectorAll('[data-q]').forEach(function(b){
    b.addEventListener('click', function(){
      var inp = root.querySelector('input[name="quantity"]');
      if (!inp) return;
      var v = (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-q'), 10);
      inp.value = Math.max(1, v);
    });
  });

  /* ---- varyant seçimi ---- */
  (function(){
    var jsonEl = document.querySelector('[data-variant-json]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var idField = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var addBtn = root.querySelector('[data-add-btn]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('.pills'));
    if (!groups.length) return;

    function money(cents){
      var el = document.getElementById('CartDrawer');
      var fmt = el ? el.getAttribute('data-money-format') : '';
      var num = (cents / 100).toFixed(2).replace('.', ',');
      var parts = num.split(',');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      num = parts.join(',');
      if (!fmt) return num + ' TL';
      var token = new RegExp('\\{\\{\\s*amount[a-z_]*\\s*\\}\\}', 'g');
      return fmt.replace(token, num) || (num + ' TL');
    }

    function selected(){
      return groups.map(function(g){
        var on = g.querySelector('[aria-pressed="true"]');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function apply(){
      var want = selected();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < want.length; j++) {
          if (want[j] !== null && v.options[j] !== want[j]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) addBtn.disabled = !match.available;
    }

    groups.forEach(function(g){
      g.addEventListener('click', function(e){
        var p = e.target.closest('.pill');
        if (!p) return;
        g.querySelectorAll('.pill').forEach(function(x){ x.setAttribute('aria-pressed', 'false'); });
        p.setAttribute('aria-pressed', 'true');
        var lbl = root.querySelector('[data-opt-label="' + g.getAttribute('data-opt-index') + '"]');
        if (lbl) lbl.textContent = p.getAttribute('data-value');
        apply();
      });
    });
  })();

  /* ---- stok çubuğu ---- */
  (function(){
    var f = root.querySelector('[data-stock-fill]');
    if (!f) return;
    var qty = parseInt(f.getAttribute('data-qty'), 10) || 0;
    var max = parseInt(f.getAttribute('data-max'), 10) || 10;
    setTimeout(function(){
      f.style.width = Math.max(6, Math.min(100, (qty / max) * 100)) + '%';
    }, 400);
  })();

  /* ---- "N kişinin sepetinde" — rastgele DEĞİL, ürün + zaman dilimi karması.
         Aynı dilimde herkes aynı sayıyı görür, yenilemede oynamaz. ---- */
  (function(){
    var el = root.querySelector('[data-in-carts]');
    if (!el) return;
    var MIN = parseInt(el.getAttribute('data-min'), 10) || 8;
    var MAX = parseInt(el.getAttribute('data-max'), 10) || 26;
    var pid = parseInt(el.getAttribute('data-product-id'), 10) || 1;
    var PERIOD = 3 * 3600;
    var bucket = Math.floor(Date.now() / 1000 / PERIOD);
    function h(x){ return (x * 2654435761) % 4294967296; }
    var h1 = h((pid % 100003) + 1);
    var h2 = h(Math.floor(h1 / 65536) + (h1 % 65536) + bucket + 1);
    var n = MIN + Math.floor(h2 / 65536 * (MAX - MIN + 1) / 65536);
    var tpl = el.getAttribute('data-template') || '__N__';
    el.innerHTML = tpl.replace('__N__', '<strong>' + n + '</strong>');
  })();

  /* ---- kargo geri sayımı — MAĞAZANIN saat dilimine göre ---- */
  (function(){
    var el = root.querySelector('[data-countdown]');
    if (!el) return;
    var body = el.querySelector('[data-countdown-body]');
    if (!body) return;
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    if (isNaN(cutoff)) cutoff = 16;
    var days = (el.getAttribute('data-days') || '').split(',')
      .map(function(s){ return parseInt(s.trim(), 10); })
      .filter(function(n){ return !isNaN(n); });
    if (!days.length) return;
    var tz = el.getAttribute('data-tz') || '+0300';
    var tzMin = 180;
    if (/^[+-]\d{4}$/.test(tz)) {
      tzMin = (tz.charAt(0) === '-' ? -1 : 1) *
        (parseInt(tz.slice(1, 3), 10) * 60 + parseInt(tz.slice(3, 5), 10));
    }
    var NAMES = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
    var tPrefix = el.getAttribute('data-t-prefix') || '';
    var tSuffix = el.getAttribute('data-t-suffix') || '';
    var tTomorrow = el.getAttribute('data-t-tomorrow') || '';
    var tNext = el.getAttribute('data-t-next') || '__DAY__';
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var now = new Date(Date.now() + tzMin * 60000);
      var day = now.getUTCDay();
      var secs = now.getUTCHours() * 3600 + now.getUTCMinutes() * 60 + now.getUTCSeconds();
      var isShip = days.indexOf(day) !== -1;
      var rem = cutoff * 3600 - secs;
      if (isShip && rem > 0) {
        body.innerHTML = tPrefix + ' <b>' + pad(Math.floor(rem / 3600)) + ':' +
          pad(Math.floor(rem % 3600 / 60)) + ':' + pad(rem % 60) + '</b> ' + tSuffix;
        el.classList.toggle('is-urgent', rem <= 3600);
      } else {
        var o = 1;
        while (o <= 7 && days.indexOf((day + o) % 7) === -1) o++;
        if (isShip && o === 1) {
          body.textContent = tTomorrow;
        } else {
          body.textContent = tNext.replace('__DAY__', NAMES[(day + o) % 7]);
        }
        el.classList.remove('is-urgent');
      }
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ---- akordeon: tek seferde tek soru ---- */
  (function(){
    var all = Array.prototype.slice.call(root.querySelectorAll('.q'));
    if (!all.length) return;
    var RM = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    function open(d){ clearTimeout(d._t); d.open = true; void d.offsetHeight; d.classList.add('is-open'); }
    function close(d){
      clearTimeout(d._t);
      d.classList.remove('is-open');
      if (RM) { d.open = false; return; }
      d._t = setTimeout(function(){ d.open = false; }, 450);
    }
    all.forEach(function(d){
      d.querySelector('summary').addEventListener('click', function(e){
        e.preventDefault();
        var willOpen = !d.classList.contains('is-open');
        all.forEach(function(o){ if (o !== d) close(o); });
        if (willOpen) open(d); else close(d);
      });
    });
  })();

  /* ---- yapışkan satın alma çubuğu ---- */
  (function(){
    var bar = document.querySelector('[data-sticky-buy]');
    var anchor = root.querySelector('.cta-row');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function(en){
      bar.classList.toggle('show', !en[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(anchor);
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
/* Gonderimden sonra Shopify ayni sayfaya donuyor. Basari/hata mesaji varsa
   paneli acik baslat, yoksa musteri gonderiminin ne olduguna dair hicbir sey
   goremiyor. */
document.addEventListener('DOMContentLoaded', function () {
  var panel = document.getElementById('ReviewFormPanel');
  if (panel && panel.querySelector('.prvf__ok, .prvf__err')) {
    panel.classList.add('is-open');
    var ac = document.querySelector('[data-prv-form]');
    if (ac) ac.setAttribute('aria-expanded', 'true');
  }
});

/* ---- masonry: kisa kartlar bosluga tirmansin ----
   Kartlarin boyu cok farkli (fotografli ~550px, metin ~190px). Duz izgarada
   satir yuksekligi en uzun karta gore belirlendigi icin satir sonlarinda
   kocaman bosluk kaliyordu. Cozum: 6px'lik ince satirlar + her karta
   yuksekligi kadar "span". Tek sutuna dusunce (mobil) devre disi. */
(function () {
  var grid = document.querySelector('[data-prv-grid]');
  if (!grid) return;
  var SATIR = 6;

  function hesapla() {
    var st = getComputedStyle(grid);
    var sutun = st.gridTemplateColumns.split(' ').length;
    var kartlar = grid.children;
    var i;

    if (sutun < 2) {
      grid.classList.remove('is-masonry');
      for (i = 0; i < kartlar.length; i++) kartlar[i].style.gridRowEnd = '';
      return;
    }

    /* Once sinifi kaldirip olc: is-masonry aktifken row-gap 0 oldugu icin
       olculen yukseklikler dogru ama aradaki bosluk hesaba katilmali. */
    var ara = parseFloat(st.columnGap) || 0;
    grid.classList.add('is-masonry');
    for (i = 0; i < kartlar.length; i++) {
      var k = kartlar[i];
      k.style.gridRowEnd = '';
      if (!k.offsetParent && k.classList.contains('is-more')) continue;
      var y = k.getBoundingClientRect().height;
      k.style.gridRowEnd = 'span ' + Math.ceil((y + ara) / SATIR);
    }
  }

  var zamanlayici;
  function ertele() {
    clearTimeout(zamanlayici);
    zamanlayici = setTimeout(hesapla, 120);
  }

  hesapla();
  window.addEventListener('resize', ertele);
  window.addEventListener('load', hesapla);
  /* gorseller yuklendikce kart boyu degisiyor, her birinde yeniden olc */
  var gorseller = grid.querySelectorAll('img');
  for (var g = 0; g < gorseller.length; g++) {
    if (!gorseller[g].complete) gorseller[g].addEventListener('load', ertele);
  }
  /* "daha fazla goster" acilinca yeni kartlar geliyor */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-prv-more]')) setTimeout(hesapla, 60);
  });
  window.petiskoYorumOlc = hesapla;
})();

/* ---- fotograf buyuteci ---- */
(function () {
  var kutu = document.getElementById('PrvLightbox');
  if (!kutu) return;
  var resim = kutu.querySelector('.prvlb__img');
  var gPrev = kutu.querySelector('[data-ph-prev]');
  var gNext = kutu.querySelector('[data-ph-next]');
  var liste = [];
  var i = 0;
  var acan = null;

  function goster(n) {
    i = (n + liste.length) % liste.length;
    resim.src = liste[i];
    /* yer tutucu 1400x1050 oranini gercek olcuyle degistir, yoksa
       yuklenene kadar yanlis oranda bir bosluk kaliyor */
    resim.onload = function () {
      if (resim.naturalWidth) {
        resim.setAttribute('width', resim.naturalWidth);
        resim.setAttribute('height', resim.naturalHeight);
      }
    };
    var tek = liste.length < 2;
    gPrev.hidden = tek;
    gNext.hidden = tek;
  }
  function ac(btn) {
    var serit = btn.closest('[data-prv-ph]');
    var hepsi = serit.querySelectorAll('[data-ph-full]');
    liste = Array.prototype.map.call(hepsi, function (b) {
      return b.getAttribute('data-ph-full');
    });
    acan = btn;
    kutu.hidden = false;
    document.body.style.overflow = 'hidden';
    goster(Array.prototype.indexOf.call(hepsi, btn));
    kutu.querySelector('[data-ph-close]').focus();
  }
  function kapat() {
    kutu.hidden = true;
    resim.src = '';
    document.body.style.overflow = '';
    /* odagi acan dugmeye geri ver, klavye kullanicisi kaybolmasin */
    if (acan) { acan.focus(); acan = null; }
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-ph-full]');
    if (thumb) { ac(thumb); return; }
    if (e.target.closest('[data-ph-close]')) { kapat(); return; }
    if (e.target.closest('[data-ph-prev]')) { goster(i - 1); return; }
    if (e.target.closest('[data-ph-next]')) { goster(i + 1); return; }
    /* zemine tiklayinca kapansin, resmin kendisine tiklayinca kapanmasin */
    if (e.target === kutu) { kapat(); }
  });
  document.addEventListener('keydown', function (e) {
    if (kutu.hidden) return;
    if (e.key === 'Escape') kapat();
    if (e.key === 'ArrowLeft') goster(i - 1);
    if (e.key === 'ArrowRight') goster(i + 1);
  });
})();

document.addEventListener('click', function (e) {
  var yaz = e.target.closest('[data-prv-form]');
  if (yaz) {
    var panel = document.getElementById('ReviewFormPanel');
    if (!panel) return;
    var acik = panel.classList.toggle('is-open');
    yaz.setAttribute('aria-expanded', acik ? 'true' : 'false');
    if (acik) {
      var ilk = panel.querySelector('input[name="contact[name]"]');
      if (ilk) ilk.focus();
    }
    return;
  }

  var btn = e.target.closest('[data-prv-more]');
  if (!btn) return;
  var kok = btn.closest('.prv');
  if (!kok) return;

  /* Hepsini birden acmiyoruz: 40 yorumlu bir urunde sayfa metrelerce
     uzuyordu. Her tikta bir "parti" aciliyor, butonda kalan sayi yaziyor. */
  var gizli = kok.querySelectorAll('.prvc.is-more');
  var parti = parseInt(btn.getAttribute('data-parti'), 10) || 6;
  var acilan = 0;

  /* Kartlar .reveal sinifi tasiyor ama IntersectionObserver sayfa yuklenirken
     kaydoldu; display:none iken gozlemci tetiklenmez. is-in'i elle veriyoruz. */
  for (var i = 0; i < gizli.length && acilan < parti; i++) {
    gizli[i].classList.remove('is-more');
    gizli[i].classList.add('is-in');
    acilan++;
  }

  var kalan = gizli.length - acilan;
  if (kalan > 0) {
    var sayac = btn.querySelector('[data-prv-kalan]');
    if (sayac) sayac.textContent = kalan;
  } else {
    btn.parentNode.removeChild(btn);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function(){
  var holder = document.querySelector('[data-recommendations]');
  if (!holder) return;
  var url = holder.getAttribute('data-url');
  if (!url) return;
  fetch(url)
    .then(function(r){ return r.text(); })
    .then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.rel');
      if (!fresh) { holder.remove(); return; }
      holder.replaceWith(fresh);

      /* AJAX ile eklenen icerik, sayfa yuklenirken calisan IntersectionObserver'a
         kayitli DEGIL. .reveal varsayilani opacity:0 oldugu icin kartlar
         gorunmez ama tiklanabilir kalir. is-in sinifini elle eklemek sart. */
      var kartlar = fresh.querySelectorAll('.reveal');
      requestAnimationFrame(function(){
        for (var i = 0; i < kartlar.length; i++) {
          (function(el, gecikme){
            setTimeout(function(){ el.classList.add('is-in'); }, gecikme);
          })(kartlar[i], i * 70);
        }
      });
    })
    .catch(function(){ holder.remove(); });
})();

  } catch(e) { console.error(e); }
})();
})();
